const init = () => {
    const THREE_SLIDER_SELECTOR = '.three-slider-common';
    const ABOUT_SLIDER_SELECTOR = '.section-about-slider'

    const $three = $(THREE_SLIDER_SELECTOR);
    const $about = $(ABOUT_SLIDER_SELECTOR);

    $three.slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        dots: true,
        responsive: [
            {
              breakpoint: 920,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
        ]
    })

    $about.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        arrows: false,
        dots: true,
        responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 768,
              settings: 'unslick',
            },
        ]
    })

}

export default {
    init
}